"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
// eslint-disable-next-line complexity
function compileInputStyleString(input = {}) {
    const { height, colors: { bg, borderHover, placeholder, bottomBordered: { active, inactive } = {} } = {} } = input;
    return `
        {
            ${height ? `--input-dependent-height: ${height};` : ''}
            ${bg ? `--input-control-bg-color: ${bg};` : ''}
            ${borderHover ? `--input-border-color-hovered: ${borderHover};` : ''}
            ${placeholder ? `--input-control-placeholder-color: ${placeholder};` : ''}
            ${active ? `--input-control-bottom-border-color-active: ${active};` : ''}
            ${inactive ? `--input-control-bottom-border-color: ${inactive};` : ''}
        }
    `;
}
function brandingInputStyles(branding = {}) {
    const { input, darkTheme } = branding;
    const lightThemeString = compileInputStyleString(input);
    if (darkTheme === null || darkTheme === void 0 ? void 0 : darkTheme.input) {
        const darkThemeString = compileInputStyleString(Object.assign(Object.assign({}, input), darkTheme.input));
        return (0, react_1.css) `
            :root ${lightThemeString}

            .pythia-surveys-root[data-theme='light'] ${lightThemeString}
            .pythia-surveys-root[data-theme='dark'] ${darkThemeString}
        `;
    }
    return (0, react_1.css) `
        :root ${lightThemeString}

        .pythia-surveys-root[data-theme='light'] ${lightThemeString}
    `;
}
exports.default = brandingInputStyles;
